// extracted by mini-css-extract-plugin
export default {"wrapper":"VC-z","viewport":"WC-z","container":"XC-z","slide":"YC-z"};